type FileReaderMethodType = "readAsArrayBuffer" | "readAsDataURL" | "readAsText";

const fileExist = (file) => {
    if (!file) {
        throw new Error("File not be found");
    }
};

export default class FileManager {
    static readAs(file: File, type: FileReaderMethodType): Promise<string | ArrayBuffer | null> {
        fileExist(file);
        if (typeof window === "undefined") {
            throw new Error("Can only use FileReader in your browser");
        }
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();

            fileReader.onload = (event: ProgressEvent<FileReader>) => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (event: ProgressEvent<FileReader>): any => {
                reject(event);
            };
            fileReader[type](file);
        });
    }

    static readAsArrayBuffer(file: File) {
        return FileManager.readAs(file, "readAsArrayBuffer") as Promise<ArrayBuffer>;
    }

    static readAsDataURL(file: File) {
        return FileManager.readAs(file, "readAsDataURL") as Promise<string>;
    }

    static readAsText(file: File) {
        return FileManager.readAs(file, "readAsText") as Promise<string>;
    }

    static async readImage(file: File) {
        fileExist(file);
        const src = await FileManager.readAsDataURL(file);
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.onload = () => {
                resolve(image);
            };
            image.onerror = (event) => {
                reject(event);
            };
            image.src = src;
        });
    }
}
